/**
 * Component: Example script
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace adBox
 */
import {moveElement} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  productCards: '.product-card',
  adBox: '[js-adbox="ad-box-1"]',
  adBox2: '[js-adbox="ad-box-2"]',
};

/**
 * Create a new adBox object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    productCards: [...document.querySelectorAll(selectors.productCards)],
    adBox: document.querySelector(selectors.adBox),
    adBox2: document.querySelector(selectors.adBox2),
  };

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.adBox) {
      return;
    }

    moveAdBox();
  }

  /**
   * Move the AD Box.
   */
  function moveAdBox() {
    if (nodeSelectors.productCards.length >= 4) {
      moveElement(nodeSelectors.adBox, nodeSelectors.productCards[4], 'prepend', '', 'hidden');
    }
    if (nodeSelectors.productCards.length >= 22 && nodeSelectors.adBox2 && nodeSelectors.adBox2.dataset.columns === 'one') {
      moveElement(nodeSelectors.adBox2, nodeSelectors.productCards[22], 'prepend', '', 'hidden');
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
